<div class="col padding no-overflow">
  <div class="row no-overflow">
    <mat-card class="no-overflow padding all">
      <mat-card-header>
        <mat-card-title>History</mat-card-title>
        <mat-tab-group
          class="tabs"
          mat-stretch-tabs
          [(selectedIndex)]="selectedTab.id"
          (selectedTabChange)="onChangeTab($event)"
        >
          <mat-tab *ngFor="let tab of tabs" [label]="tab.name"></mat-tab>
        </mat-tab-group>
      </mat-card-header>
      <!-- Data Table -->
      <app-data-table
        class="card-table"
        #table
        [tableName]="'keySystems'"
        [viewPageSize]="50"
        [displayColumns]="reportDisplayColumns"
        [subject]="filteredReport"
        [pagination]="true"
      >
      </app-data-table>
    </mat-card>
  </div>
</div>
